"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference path="./types/deferred-regl.d.ts" />
/// <reference types="./types/deferred-regl" />
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var deferred_regl_1 = __importDefault(require("deferred-regl"));
var dregl = deferred_regl_1.default();
// Wrap the deferred-regl wrapper
// so that it returns a react element when called
// within a react context
var reactRegl = function (definitionProps) {
    var drawCommand = null;
    // TODO execution props should enforce type safety of DynamicVariables for user defined `regl.prop`
    var ReactReglComponent = function (executionProps, contextOrRef) {
        if (executionProps && (contextOrRef === null || contextOrRef === void 0 ? void 0 : contextOrRef.reactify) === true) {
            var merged = { definitionProps: definitionProps, executionProps: executionProps, dregl: dregl };
            var children = executionProps.children ? executionProps.children : null;
            return react_1.default.createElement('ReglDraw', merged, children);
        }
        if (drawCommand === null) {
            drawCommand = dregl(definitionProps);
        }
        if (drawCommand === null) {
            throw new Error('failed to initalize regl drawCommand');
        }
        var drawCommandProps = executionProps ? executionProps : {};
        return drawCommand(drawCommandProps, contextOrRef);
    };
    ReactReglComponent.contextTypes = {
        reactify: prop_types_1.default.bool
    };
    return ReactReglComponent;
};
Object.setPrototypeOf(reactRegl, dregl);
exports.default = reactRegl;
